import { fbDB } from "../config/firebase";
import {
  AGENDA_ADD,
  EARLY_VOTING_WATCH_ON,
  EARLY_VOTING_WATCH_OFF,
  EARLY_VOTING_TARGET_UPDATE
} from "./types";

export const earlyVotingWatchOn = () => async dispatch => {
  fbDB.ref("/earlyVoting").on("value", snapshot =>
    dispatch({
      type: EARLY_VOTING_WATCH_ON,
      payload: snapshot.val()
    })
  );
};

export const earlyVotingWatchOff = () => async dispatch => {
  fbDB.ref("/earlyVoting").off();
  return dispatch({
    type: EARLY_VOTING_WATCH_OFF,
    payload: null
  });
};

export const agendaAdd = (cCode, agenda) => async dispatch => {
  fbDB
    .ref(`/earlyVoting/${cCode}`)
    .set({ agenda })
    .then(() => {
      return dispatch({
        type: AGENDA_ADD,
        payload: null
      });
    });
};

export const earlyVotingTargetToggle = (cCode, uid) => async dispatch => {
  fbDB.ref(`/earlyVoting/${cCode}/absent`).transaction(data => {
    if (data === null) {
      return [uid];
    } else if (data.filter(v => v === uid).length) {
      return data.filter(v => v !== uid);
    } else if (!data.filter(v => v === uid).length) {
      return [...data, uid];
    }
  });
};
